import { render } from "./DocInfo.vue?vue&type=template&id=db5d7e26&scoped=true"
import script from "./DocInfo.vue?vue&type=script&lang=js"
export * from "./DocInfo.vue?vue&type=script&lang=js"

import "./DocInfo.vue?vue&type=style&index=0&id=db5d7e26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5d7e26"]])

export default __exports__